<template>
  <div id="app">
    <Computer />
  </div>
</template>

<script>
import Computer from "./views/computer";
export default {
  name: "App",
  components: {
    Computer,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  max-width: 540px;
  margin: 0 auto;
}
</style>
